<p-dialog
  [(visible)]="visible"
  [baseZIndex]="9999"
  [closable]="false"
  [draggable]="false"
  header="Openingstijden"
  styleClass="intro-dialog"
>
  <span>{{ bannerText() }}</span>

  <p-button (click)="visible.set(false)">OK</p-button>
</p-dialog>
